import '../scss/btf/btf.scss';
import MicroModal from "micromodal";
import { Menu } from './components/menu/menu';
import { Search } from "./components/search/search";
import { scrollMenu } from './components/scrollMenu/scrollMenu';
import { CounterBlock } from './components/counter-block/counter-block';

// @ts-ignore
import Tabs from '../js/vanilla-js-tabs-master/src/javascript/vanilla-js-tabs';

class HideLoader {
	constructor() {
		document.body.querySelector('.loader').classList.add('opacize');
		setTimeout(() => { document.body.querySelector('.loader').classList.add('z-out'); });
	}
}


document.addEventListener('DOMContentLoaded', function () {

	// if ( document.querySelector('.flip-card') ) {
	// 	document.querySelectorAll('.flip-card').forEach( (flipcard: HTMLElement) => {
	// 		flipcard.addEventListener( 'click', function() {
	// 			flipcard.classList.toggle('is-flipped');
	// 		});
	// 	} );
	// }

	MicroModal.init();

	new scrollMenu();

	if (document.querySelector('.nlbutton')) {
		const button = document.querySelector('.nlbutton');
		button.addEventListener('click', function () {
			MicroModal.show("newsletter-modal");
		});
	}

	if (document.querySelector('.count-value')) {
		new CounterBlock();
	}

	if (document.querySelector('.menu-btn')) {
		new Menu();
	}

	if (document.querySelector('.search-btn')) {
		new Search();
	}


	if (document.querySelector('.gallery')) {
		import('./components/gallery/gallery').then(c => {
			document.querySelectorAll('.gallery').forEach((gallery: HTMLElement) => {
				new c.Gallery(gallery);
			});
		});
	}

	if (document.querySelector('.accordion')) {
		import('./components/accordion/accordion').then(c => {
			document.querySelectorAll('.accordion').forEach((accordionList: HTMLElement) => {
				new c.Accordion(accordionList);
			});
		});
	}

	if (document.querySelector('.video-gallery')) {
		import('./components/video-gallery/video-gallery').then(c => {
			document.querySelectorAll('.video-gallery').forEach((gallery: HTMLElement) => {
				new c.VideoGallery(gallery);
			});
		});
	}

	if (document.querySelector('.carousel')) {
		import('./components/carousel/carousel').then(c => {
			document.querySelectorAll('.carousel').forEach((carousel: HTMLElement) => {
				new c.Carousel(carousel);
			});
		});
	}

	if (document.querySelector('.muteToggle')) {
		document.querySelectorAll('.muteToggle').forEach((button: HTMLElement) => {
			button.onclick = (e) => {
				let container = button.closest(".video-wrapper");
				container.classList.toggle('is-unmuted');
				let video = <HTMLVideoElement>container.getElementsByTagName('video')[0];
				if (video) {
					video.muted = !video.muted;
				}
			}
		});
	}

	if (document.querySelector('.playToggle')) {
		document.querySelectorAll('.playToggle').forEach((button: HTMLElement) => {
			button.onclick = (e) => {
				let container = button.closest(".video-wrapper");
				let video = <HTMLVideoElement>container.getElementsByTagName('video')[0];
				container.classList.toggle('is-playing');
				if (video.paused) {
					video.play();
				} else {
					video.pause();
				}
			}
		});
	}

	if (document.getElementById('tabs')) {
		new Tabs({
			elem: 'tabs',
			open: 0
		});
	}

	if (document.querySelector('.documents-list')) {
		let documentsLists = document.querySelectorAll('.documents-list');

		documentsLists.forEach((documentList: HTMLElement) => {
			let documents = documentList.querySelectorAll('.group-document');
			let _a = Array.from(documentList.querySelectorAll('.term-switcher'));
			let tabs = document.getElementById('tabs');
			_a.forEach((a: HTMLAnchorElement) => {
				a.onclick = (e) => {
					if (window.innerWidth > 768) {
						tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
					}
					_a.map(aa => {
						aa.classList.remove('active');
					})
					a.classList.add('active');
					Array.from(documents).map((d: HTMLElement) => {
						d.classList.remove('active');
						if (d.dataset.rel === a.dataset.rel) d.classList.add('active');
					})
				}
			});
		})
	}

	var input = document.getElementById('file-upload');
	var infoArea = document.getElementById('file-upload-filename');

	if (input) {
		input.addEventListener('change', showFileName);

		function showFileName(this: HTMLElement, ev: Event) {
			// the change event gives us the input it occurred in 
			ev.preventDefault();
			let file = (<HTMLInputElement>ev.target).files[0];
			infoArea.textContent = 'File selezionato: ' + file.name;
		}
	}


	let pageFound = false;
	if (!pageFound) {
		new HideLoader();
	}

}, false);